/* eslint-disable react-hooks/exhaustive-deps */
import {
  getAllSalesInvoiceApi,
  getAllSalesContractApi,
} from "../../services/_sales";
import {
  formatDate,
  formatAmount,
  formatString,
} from "../../components/Helper";
import moment from "moment";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import Spinner from "../../theme/Spinner";
import Pagination from "../../components/Pagination";
import { getBuyerNameListApi } from "../../services/_buyer";
import { CURRENCY } from "../../components/Constants";
import { SalesInvoiceStatus } from "../../components/Enums";
import { useEffect, useRef, useState } from "react";
import { getProductNameListApi } from "../../services/_product";
import { productWiseSalesReportApi } from "../../services/_report";
import ReactSelect from "react-select";

interface CustomCSVLink extends HTMLAnchorElement {
  link: HTMLAnchorElement;
}

const ProductWiseSalesReport = () => {
  const [records, setRecords] = useState([]);
  const [productList, setProductList] = useState<any>([]);
  const [buyerList, setBuyerList] = useState<any[]>([]);
  const [saleList, setSaleList] = useState<any[]>([]);
  const [saleOrderList, setSaleOrderList] = useState<any[]>([]);
  const [filteredSales, setFilteredSales] = useState<any[]>([]);
  const [filteredSalesOrders, setFilteredSalesOrders] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [productFilter, setProductFilter] = useState<string>("");
  const [buyerFilter, setBuyerFilter] = useState<string>("");
  const [saleFilter, setSaleFilter] = useState<string>("");
  const [saleOrderFilter, setSaleOrderFilter] = useState<string>("");
  const [dateRange, setDateRange] = useState(null);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const csvLinkRef = useRef<CustomCSVLink>(null);
  const [exportData, setExportData] = useState([]);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");
  const productRef = useRef<any>(null);

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };

  const getProdWiseList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string,
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;

    if (isFilter) {
      if (saleFilter) {
        query += `&sales_contract_id=${saleFilter}`;
      }
      if (saleOrderFilter) {
        query += `&sales_invoice_id=${saleOrderFilter}`;
      }
      if (buyerFilter) {
        query += `&buyer_id=${buyerFilter}`;
      }
      if (productFilter) {
        query += `&product_id=${productFilter}`;
      }
      if (dateRange) {
        query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
        query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }
    }

    const result: any = await productWiseSalesReportApi(query);

    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setTotalRecords(result.data.total_records);
      setTotalPages(totalPagesCount);
      setRecords(result.data.records);
      setTotalQuantity(result.data.total_quantity);
      setTotalAmount(result.data.total_amount);
    }
    setLoading(false);
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const fetchProductData = async () => {
    try {
      const result: any = await getProductNameListApi();
      setProductList(result.data);
    } catch (error) {
      console.error("Error fetching product name list", error);
    }
  };

  const fetchBuyerData = async () => {
    const result: any = await getBuyerNameListApi();
    if (result.isSuccess) {
      setBuyerList(result?.data);
    }
  };

  const fetchSalesContractData = async () => {
    const result: any = await getAllSalesContractApi();
    if (result.isSuccess) {
      setSaleList(result.data);
      setFilteredSales(result?.data);
    }
  };

  const fetchSalesOrdersData = async () => {
    const result: any = await getAllSalesInvoiceApi();
    if (result.isSuccess) {
      setSaleOrderList(result.data);
      setFilteredSalesOrders(result?.data);
    }
  };

  const filterList = async () => {
    setApplyFilter(true);
    getProdWiseList(page, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);
    if (productRef.current) {
      productRef.current.clearValue();
    }
    setProductFilter("");
    setSaleFilter("");
    setBuyerFilter("");
    setSaleOrderFilter("");
    setDateRange(null);
    setFilteredSales(saleList);
    setFilteredSalesOrders(saleOrderList);
    getProdWiseList(page, perPage);
  };

  const getFileName = () => {
    const filerName = "product-wise-sales-report";
    return `${filerName}-${moment().format("MM-DD-YYYY-HH-mm-ss")}.csv`;
  };

  const exportProductWiseSalesList = async () => {
    setExportData([]);
    let csvHeader: any;
    let csvData: any;
    let csvFooter: any;

    let query = `export=true`;
    if (saleFilter) {
      query += `&sales_contract_id=${saleFilter}`;
    }
    if (saleOrderFilter) {
      query += `&sales_invoice_id=${saleOrderFilter}`;
    }
    if (buyerFilter) {
      query += `&buyer_id=${buyerFilter}`;
    }
    if (productFilter) {
      query += `&product_id=${productFilter}`;
    }
    if (dateRange) {
      query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
      query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
    }
    if (sortKey && sortType) {
      query += `&sort_key=${sortKey}&sort_type=${sortType}`;
    }

    const result: any = await productWiseSalesReportApi(query);
    if (result.isSuccess) {
      if (result.data.records) {
        csvHeader = [
          "Sr No.",
          "Product",
          "Buyer",
          "Sales Contract No",
          "Commercial Invoice No",
          "Price",
          "Quantity (MTS)",
          "Total Amount",
          "Commercial Invoice Status",
          "Commercial Invoice Date",
        ];
        csvData = result.data.records.map((item: any, index: number) => [
          (index + 1).toString(),
          item?.product?.name || "",
          item?.sales_invoice?.buyer?.name || "",
          item?.sales_contract?.contract_no || "",
          item?.sales_invoice.invoice_no || "",
          `${CURRENCY.USD.SYMBOL}${formatAmount(item.price)}`,
          item?.quantity || "",
          `${CURRENCY.USD.SYMBOL}${formatAmount(item.total_amount)}`,
          formatString(item?.sales_invoice.status) || "",
          formatDate(item.sales_invoice.invoice_date),
        ]);
        csvFooter = [
          "",
          "",
          "",
          "",
          "",
          "",
          totalQuantity,
          `${CURRENCY.USD.SYMBOL}${formatAmount(totalAmount)}`,
          "",
          "",
        ];

        const exportData: any = [csvHeader, ...csvData, csvFooter];
        setExportData(exportData);

        if (csvLinkRef.current?.link) {
          setTimeout(() => {
            csvLinkRef.current!.link.click();
          }, 0);
        }
      }
    }
  };

  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getProdWiseList(page, perPage, true, key, type);
  };

  const filterSuggestions = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "buyer_id") {
      const saleData = value
        ? saleList.filter(
            (sale_contract: any) => sale_contract.buyer_id === value,
          )
        : saleList;

      const saleOrderData = value
        ? saleOrderList.filter(
            (sale_order: any) => sale_order.buyer_id === value,
          )
        : saleOrderList;

      setSaleFilter("");
      setSaleOrderFilter("");
      setFilteredSales(saleData);
      setFilteredSalesOrders(saleOrderData);
    }

    if (name === "sales_contract_id") {
      const newData = value
        ? saleOrderList.filter(
            (sale_order: any) => sale_order.sales_contract_id === value,
          )
        : saleOrderList;

      setSaleOrderFilter("");
      setFilteredSalesOrders(newData);
    }
  };

  useEffect(() => {
    if (page && perPage) {
      getProdWiseList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  useEffect(() => {
    fetchProductData();
    fetchBuyerData();
    fetchSalesContractData();
    fetchSalesOrdersData();
  }, []);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Product Wise Sales Report</h5>
          </div>
          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
            <Link
              to={"#"}
              className="btn btn-primary waves-effect waves-light"
              type="button"
              onClick={() => {
                exportProductWiseSalesList();
              }}
            >
              <span>
                <i className="ti ti-download me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Download Excel</span>
              </span>
            </Link>
            <CSVLink
              data={exportData}
              filename={getFileName()}
              className="d-none"
              ref={csvLinkRef as any}
            >
              <span>
                <i className="ti ti-download me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Download Excel</span>
              </span>
            </CSVLink>
          </div>
        </div>

        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Commercial Invoice Date:
                      </label>
                      <DateRangePicker
                        format="dd-MM-yyyy"
                        className="form-control"
                        placeholder="From Date ~ To Date"
                        value={dateRange}
                        onChange={(values: any) => {
                          setDateRange(values);
                        }}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Product:
                      </label>
                      {(() => {
                        const selectedOption = productList?.find(
                          (option: any) => option.id === productFilter,
                        );
                        const formatOptionLabel = (
                          option: any,
                          { context }: any,
                        ) => {
                          if (context === "value") {
                            return option.name;
                          } else {
                            return (
                              <div>
                                <label className="form-label">
                                  {option.name}
                                </label>
                                <br />
                                <span className="form-label">
                                  {option.description}
                                </span>
                              </div>
                            );
                          }
                        };
                        return (
                          <ReactSelect
                            ref={productRef}
                            classNamePrefix="react-select"
                            placeholder="Select Product"
                            options={productList}
                            getOptionLabel={(option: any) => option.name}
                            formatOptionLabel={formatOptionLabel}
                            getOptionValue={(option: any) => option.id}
                            onChange={(selectedOption: any) => {
                              setProductFilter(selectedOption?.id || "");
                            }}
                            value={selectedOption}
                            isClearable
                            isSearchable
                          />
                        );
                      })()}
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        htmlFor="buyer_id"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Buyer:
                      </label>
                      <select
                        className="form-select"
                        name="buyer_id"
                        id="buyer_id"
                        value={buyerFilter}
                        onChange={(e) => {
                          setBuyerFilter(e.target.value);
                          filterSuggestions(e);
                        }}
                      >
                        <option defaultChecked value={""}>
                          Select Buyer
                        </option>
                        {buyerList.map((e: any) => {
                          return (
                            <option value={e.id} key={e.id}>
                              {e.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        htmlFor="sales"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Sales Contract No:
                      </label>
                      <select
                        className="form-select"
                        name="sales_contract_id"
                        id="sales_contract_id"
                        value={saleFilter}
                        onChange={(e) => {
                          setSaleFilter(e.target.value);
                          filterSuggestions(e);
                        }}
                      >
                        <option defaultChecked value={""}>
                          Select Sales Contract No
                        </option>
                        {filteredSales.map((e: any) => {
                          return (
                            <option value={e.id} key={e.id}>
                              {e.contract_no}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        htmlFor="sales_invoice_id"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Commercial Invoice No:
                      </label>
                      <select
                        name="sales_invoice_id"
                        className="form-select"
                        id="sales_invoice_id"
                        value={saleOrderFilter}
                        onChange={(e) => {
                          setSaleOrderFilter(e.target.value);
                        }}
                      >
                        <option defaultChecked value={""}>
                          Select Commercial Invoice No
                        </option>
                        {filteredSalesOrders.map((e: any) => {
                          return (
                            <option value={e.id} key={e.id}>
                              {e.invoice_no}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="col-12">
                      <button
                        type="button"
                        onClick={filterList}
                        className="btn btn-primary"
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        onClick={resetList}
                        className="btn btn-label-github ms-5"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}
          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("product")}
                >
                  Product
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("buyer")}
                >
                  Buyer
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("contract_no")}
                >
                  Sales Contract No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("invoice_no")}
                >
                  Commercial Invoice No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("price")}
                >
                  Price
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("quantity")}
                >
                  Quantity (MTS)
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("total_amount")}
                >
                  Total Amount
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("status")}
                >
                  Commercial Invoice Status
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("invoice_date")}
                >
                  Commercial Invoice Date
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                <>
                  {records.map((item: any, i: number) => {
                    let statusClass = "";
                    if (
                      item?.sales_invoice.status === SalesInvoiceStatus.PENDING
                    ) {
                      statusClass = `bg-label-warning`;
                    } else if (
                      item?.sales_invoice.status ===
                      SalesInvoiceStatus.COMPLETED
                    ) {
                      statusClass = `bg-label-success`;
                    } else {
                      statusClass = `bg-label-secondary`;
                    }
                    return (
                      <tr key={item.id}>
                        <td>{(page - 1) * perPage + 1 + i}</td>
                        <td>{item?.product?.name || ""}</td>
                        <td>{item?.sales_invoice?.buyer?.name || ""}</td>
                        <td>{item?.sales_contract?.contract_no || ""}</td>
                        <td>{item?.sales_invoice.invoice_no || ""}</td>
                        <td>
                          {CURRENCY.USD.SYMBOL}
                          {formatAmount(item.price)}
                        </td>
                        <td>{formatAmount(item?.quantity, 3)}</td>
                        <td>
                          {CURRENCY.USD.SYMBOL}
                          {formatAmount(item.total_amount)}
                        </td>
                        <td>
                          <span className={`badge ${statusClass} me-1`}>
                            {formatString(item?.sales_invoice.status)}
                          </span>
                        </td>
                        <td>{formatDate(item.sales_invoice.invoice_date)}</td>
                      </tr>
                    );
                  })}
                  <tr key="total-amount-row" style={{ fontWeight: "bold" }}>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{formatAmount(totalQuantity, 3)}</td>
                    <td>
                      {CURRENCY.USD.SYMBOL}
                      {formatAmount(totalAmount)}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={11} className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={records}
          prevButton={prevButton}
          nextButton={nextButton}
        />
      </div>
    </>
  );
};

export default ProductWiseSalesReport;
